import {
  FETCH_TOPIC_CLOUDS_FAILURE,
  FETCH_TOPIC_CLOUDS_REQUEST,
  FETCH_TOPIC_CLOUDS_SUCCESS,
  FETCH_TOPIC_CLOUD_FAILURE,
  FETCH_TOPIC_CLOUD_REQUEST,
  FETCH_TOPIC_CLOUD_SUCCESS,
  FETCH_TOPIC_FAILURE,
  FETCH_TOPIC_REQUEST,
  FETCH_TOPIC_SUCCESS,
  CLEAR_CURRENT_TOPIC_CLOUD
} from '../actions/topicclouds'

import { SET_CURRENT_ORGANIZATION } from '../actions/organization'

const initialState = {
  items: [],
  isFetchingTopicClouds: false,
  isFetchingTopic: false,
  isFetchingTopicCloud: false,
  currentTopicCloud: null,
  currentTopic: null
}

export function topicclouds(state = initialState, action) {
  switch (action.type) {
    case FETCH_TOPIC_CLOUDS_REQUEST:
      return Object.assign({}, state, {
        isFetchingTopicClouds: true,
        currentTopicCloud: null,
        currentTopic: null
      })
    case FETCH_TOPIC_CLOUDS_SUCCESS:
      return Object.assign({}, state, {
        isFetchingTopicClouds: false,
        items: action.topicclouds
      })
    case FETCH_TOPIC_CLOUDS_FAILURE:
      return Object.assign({}, state, {
        isFetchingTopicClouds: false,
        items: []
      })
    case FETCH_TOPIC_CLOUD_REQUEST:
      return Object.assign({}, state, {
        isFetchingTopicCloud: true,
        currentTopic: null
      })
    case FETCH_TOPIC_CLOUD_SUCCESS:
      return Object.assign({}, state, {
        isFetchingTopicCloud: false,
        currentTopicCloud: action.topiccloud
      })
    case FETCH_TOPIC_CLOUD_FAILURE:
      return Object.assign({}, state, {
        isFetchingTopicCloud: false,
        currentTopicCloud: null
      })
    case FETCH_TOPIC_REQUEST:
      return Object.assign({}, state, {
        isFetchingTopic: true
      })
    case FETCH_TOPIC_SUCCESS:
      return Object.assign({}, state, {
        isFetchingTopic: false,
        currentTopic: action.topic
      })
    case FETCH_TOPIC_FAILURE:
      return Object.assign({}, state, {
        isFetchingTopic: false,
        currentTopic: null
      })
    case CLEAR_CURRENT_TOPIC_CLOUD:
      return Object.assign({}, state, {
        currentTopicCloud: null,
        currentTopic: null
      })
    case SET_CURRENT_ORGANIZATION:
      return Object.assign({}, state, {
        items: [],
        isFetchingTopicClouds: false,
        isFetchingTopic: false,
        isFetchingTopicCloud: false,
        currentTopicCloud: null,
        currentTopic: null
      })
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/topicclouds.js